module.exports = __webpack_public_path__ + "img/business-valuation-2.4cd1b26a.png";